import { render, staticRenderFns } from "./remittance-distribution.vue?vue&type=template&id=a93fb8c6"
import script from "./remittance-distribution.vue?vue&type=script&lang=js"
export * from "./remittance-distribution.vue?vue&type=script&lang=js"
import style0 from "./remittance-distribution.vue?vue&type=style&index=0&id=a93fb8c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports